import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { DocumentLibraryConstants } from '../../document-library-constants';
import { DocumentPhaseChange } from '../../models/documentPhaseChange';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-cancel-button',
  templateUrl: './cancel-button.component.html',
  styleUrls: ['./cancel-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CancelButtonComponent implements OnInit {
cancelButton !: DocumentPhaseChange;
@Output() isCancellationModalVisible = new EventEmitter<boolean>();
display: boolean = false;
@Input() documentNumber!: string;
@Input() documentVersion!: string;
reason: string = '';
mandatoryFields = this.getDefaultMandatoryFields();
errorMessages: string[] = [];
showCancelButton: boolean = false;
@Output() setDocumentDetailsLoader = new EventEmitter<any>();

  constructor(private documentService: DocumentService, private messageService: MessageService) { }

  ngOnInit(): void {
  }

  documentCancelPhase(){
    this.display=true;
  }


  getDefaultMandatoryFields() {
    return {
      reason: false,
    }
  }
  confirmClick(){
    this.errorMessages=[];
   this.validateCancellationModalControls();
   if(this.errorMessages.length === 0){
    this.setDocumentDetailsLoader.emit(true);
    this.cancelButton = {
      reason: this.reason,
      phase:8
    }

    this.documentService.moveDocumentToCancelPhase(this.documentNumber,this.documentVersion,this.cancelButton)
    .pipe(
      catchError((err) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${err.error}`,
        });
        this.setDocumentDetailsLoader.emit(false);
        return throwError(() => err);
      })
    )
    .subscribe(
      (serviceData)=>{
        this.display=false;
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Info,
          summary: `${DocumentLibraryConstants.MoveToCancelledPhase_Success}`
        });
        setTimeout(() => {
        this.setDocumentDetailsLoader.emit(false);
        this.isCancellationModalVisible.emit(true);
        this.display = false;
        }, 2000)
    });
  }
}
validateCancellationModalControls(){
  const isWhitespace = (this.reason || '').trim().length === 0;
  if(this.reason === "" || this.reason === undefined || this.reason?isWhitespace:null){
        this.mandatoryFields.reason = true;
        this.errorMessages.push(DocumentLibraryConstants.MoveToCancelledPhase_Reason_Required); 
  }
}

  cancelClick():void{
    this.display=false;
    this.resetModal();    
  }

  resetModal() {
    this.errorMessages = [];
    this.mandatoryFields.reason = false;
    this.reason = '';
  }
  reloadDocumentDetail() {
    this.isCancellationModalVisible.emit(false);
    this.resetModal();
  }
}
